module.exports = __webpack_public_path__ + "media/images/icon_list/share-6ea3ae7a9f9d0b9b831b3dae2fcd053d.svg";